module.exports = __webpack_public_path__ + "media/images/lb/242-4a42e5758951d98003bc2d7866bb0207.svg";